import mixpanel from "mixpanel-browser";

const TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
let enabled = false;

if (TOKEN) {
  mixpanel.init(TOKEN, {
    debug: process.env.NODE_ENV === "development",
    persistence: "localStorage",
    track_pageview: false,
    ignore_dnt: false,
  });
  enabled = true;
}

// SPA virtual page view
export const trackPageView = (path) => {
  if (!enabled) return;
  mixpanel.track("Page View", {
    page_path: path,
    page_title: document.title,
    page_url: window.location.href,
    referrer: document.referrer,
  });
};

// Generic event helper with page context. Standard event names:
// "Page View" for views and lifecycle/success milestones, "Button Clicked"
// for actions, "Link Clicked" for navigation — with element_text populated
// to identify what happened.
export const trackEvent = (name, props = {}) => {
  if (!enabled) return;
  mixpanel.track(name, { page_path: window.location.pathname, ...props });
};

const std = (name, props = {}) => {
  const p = { ...props };
  delete p.element_text;
  return { element_text: name, ...p };
};

/** Button-style action, identified by element_text. */
export const trackButton = (elementText, props = {}) =>
  trackEvent("Button Clicked", std(elementText, props));

/** Link/navigation action, identified by element_text. */
export const trackLink = (elementText, props = {}) =>
  trackEvent("Link Clicked", std(elementText, props));

/** View or lifecycle milestone, identified by element_text. */
export const trackPageEvent = (elementText, props = {}) =>
  trackEvent("Page View", std(elementText, props));

// Global click tracking: tracks every button and link click on every page
// via a single delegated listener. Initialized once from Layout.
let clickTrackingInit = false;
export const initClickTracking = () => {
  if (!enabled || clickTrackingInit) return;
  clickTrackingInit = true;
  document.addEventListener(
    "click",
    (e) => {
      const el = e.target.closest('a, button, [role="button"]');
      if (!el) return;
      const isLink = el.tagName.toLowerCase() === "a";
      const href = isLink ? el.getAttribute("href") : undefined;
      const text = (el.innerText || el.getAttribute("aria-label") || "")
        .trim()
        .replace(/\s+/g, " ")
        .slice(0, 120);
      mixpanel.track(isLink ? "Link Clicked" : "Button Clicked", {
        page_path: window.location.pathname,
        element_text: text || undefined,
        element_testid: el.getAttribute("data-testid") || undefined,
        href: href || undefined,
        link_external: href ? /^(https?:)?\/\//.test(href) : undefined,
      });
    },
    true,
  );
};

export default mixpanel;
